//剔除符合条件的数组
export const removeArr = (arrPerson, objPropery, objValue) => {
    let arr = new Array();
    arrPerson.forEach(function (item, index, input) {
        if (item[objPropery] != objValue) {
            arr.push(item)
        }
    });
    return arr
};

//筛选符合条件的数组
export const getArr = (arrPerson, objPropery, objValue) => {
    let arr = new Array();
    arrPerson.forEach(function (item, index, input) {
        if (item[objPropery] == objValue) {
            arr.push(item)
        }
    });
    return arr
};

//计算时间    type： 0今天  1昨天  7近七天  30近一月  31本月  32上一月
export const countTime = (type, fly) => {
    fly = (fly == '' || fly == null || typeof (fly) == "undefined") ? '' : fly;
    let today = new Date();
    let state = '', end = '';
    end = today;
    switch (type) {
        case 0:
            state = today;
            fly != '' ? end = new Date(today - (-86400000)) : '';
            break;
        case 1:
        case 31:
            state = new Date(today - 86400000);
            fly != '' ? end = today : end = new Date(today - 86400000);
            break;
        case 7:
            state = new Date(today - 6 * 86400000);
            fly != '' ? end = new Date(today - (-86400000)) : '';
            break;
        case 10:
            state = new Date(today - 9 * 86400000);
            fly != '' ? end = new Date(today - (-86400000)) : '';
            break;
        case 30:
            state = new Date(today - 29 * 86400000);
            fly != '' ? end = new Date(today - (-86400000)) : '';
            break;
        case 32:
            state = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            end = new Date(today.getFullYear(), today.getMonth(), state.getDate() - 1);
            break;
    }
    let sy = state.getFullYear();
    let sm = state.getMonth() + 1;
    let sd = state.getDate();

    let ey = end.getFullYear();
    let em = end.getMonth() + 1;
    let ed = end.getDate();

    sm = (sm >= 10 ? sm : '0' + sm);
    sd = (sd >= 10 ? sd : '0' + sd);
    em = (em >= 10 ? em : '0' + em);
    ed = (ed >= 10 ? ed : '0' + ed);

    type == 31 ? sd = '01' : '';

    return sy + '-' + sm + '-' + sd + ',' + ey + '-' + em + '-' + ed
};

//计算时间    type： 0今天  1昨天  7近七天  30近一月  31本月  32上一月  （液位统计）
export const countTime2 = (type, fly) => {
    fly = (fly == '' || fly == null || typeof (fly) == "undefined") ? '' : fly;
    let today = new Date();
    let state = '', end = '';
    end = today;
    switch (type) {
        case 0:
            state = today;
            fly != '' ? end = today : '';
            break;
        case 1:
            state = new Date(today - 86400000);
            fly != '' ? end = new Date(today - 86400000) : '';
            break;
        case 7:
            state = new Date(today - 6 * 86400000);
            fly != '' ? end = new Date(today) : '';
            break;
        case 10:
            state = new Date(today - 9 * 86400000);
            fly != '' ? end = new Date(today) : '';
            break;
        case 30:
            state = new Date(today - 29 * 86400000);
            fly != '' ? end = new Date(today - (-86400000)) : '';
            break;
        case 31:
            state = new Date(today - 86400000);
            fly != '' ? end = today : end = new Date(today - 86400000);
            break;
        case 32:
            state = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            end = new Date(today.getFullYear(), today.getMonth(), state.getDate() - 1);
            break;
    }
    let sy = state.getFullYear();
    let sm = state.getMonth() + 1;
    let sd = state.getDate();

    let ey = end.getFullYear();
    let em = end.getMonth() + 1;
    let ed = end.getDate();

    sm = (sm >= 10 ? sm : '0' + sm);
    sd = (sd >= 10 ? sd : '0' + sd);
    em = (em >= 10 ? em : '0' + em);
    ed = (ed >= 10 ? ed : '0' + ed);

    type == 31 ? sd = '01' : '';

    return sy + '-' + sm + '-' + sd + ',' + ey + '-' + em + '-' + ed
};

//判断某元素是否有某class
export const hasClass = (element, cls) => {
    return ('' + element.className + '').indexOf('' + cls + '') > -1;
};
// 格式化格林威治时间
export const fermitTime = (time) => {
    if (!time) {
        return ''
    }
    let now = new Date(time);
    let year = now.getFullYear();
    let mon = now.getMonth() + 1;
    let date = now.getDate();
    if (mon < 10) {
        mon = '0' + mon;
    }
    ;
    if (date < 10) {
        date = '0' + date;
    }
    ;

    return year + '-' + mon + '-' + date;
};
// 分钟数转化为天和小时数
export const timeStamp = (StatusTime) => {
    let st = Number(StatusTime)
    let day = parseInt(st / 60 / 24);
    let hour = parseInt(st / 60 % 24);
    let min = parseInt(st % 60);
    let StatusMinute = "";
    if (day > 0) {
        StatusMinute = day + "天";
    }
    if (hour > 0) {
        StatusMinute += hour + "小时";
    }
    if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
    }
    return StatusMinute;
};
//给定时间锚点，返回时间字符串
export const getTime = (myDate, type) => {
    let date = myDate;
    if (type == 'str') {
        date = new Date(myDate * 1000);
    }
    ;
    let sy = date.getFullYear();
    let sm = date.getMonth() + 1;
    let sd = date.getDate();
    let sh = date.getHours();
    let smi = date.getMinutes();
    let se = date.getSeconds();

    sm = sm >= 10 ? sm : '0' + sm;
    sd = sd >= 10 ? sd : '0' + sd;
    sh = sh >= 10 ? sh : '0' + sh;
    smi = smi >= 10 ? smi : '0' + smi;
    se = se >= 10 ? se : '0' + se;

    return sy + '-' + sm + '-' + sd + ' ' + sh + ':' + smi + (type == 's' ? ':' + se : '')
}

//几小时前报警
export const beforeTime = (data) => {
    let last = new Date(data);
    let date = new Date();
    let h = '';
    if (date > last) {
        var jujin = (date - last) / 1000;
        if (jujin > 172800) {
            h = data.substring(0, 19);
        } else {
            let day = Math.floor(jujin / 86400);
            h += (day > 0 ? day + '天' : '');

            let hover = Math.floor(jujin % 86400 / 3600);
            h += (hover > 0 ? hover + '小时' : '');

            let mouse = Math.floor(jujin % 86400 % 3600 / 60);
            h += (mouse > 0 ? mouse + '分钟' : '');

//          let second = Math.floor(jujin%86400%3600%60);
//          h += (second>0?second+'秒':'');           
            h += '前';
        }
        ;
        return h
    }
}

//站点可用时长
export const howLong = (data, type) => {
    let howLong = '';
    if (data == 525600.00 || data == '') {
        return howLong = '-'
    }
    if (data == 0.00 || data == 0.0 || data == 0) {
        return '0分'
    }

    switch (type) {
        case 'h':
            if (data > 48) {
                howLong = '大于2天';
            } else {
                let day = Math.floor(data / 24);
                let h = Math.floor(data % 24);
                let m = Math.floor(data % 24 % 1 * 60);

                howLong = (day > 0 ? day + '天' : '') + (h > 0 ? h + '小时' : '') + (m > 0 ? m + '分' : '');
            }
            break;

        default:
            if (data > 2880) {
                howLong = '大于2天';
            } else {
                let day = Math.floor(data / 1440);
                let h = Math.floor(data % 1440 / 60);
                let m = Math.floor(data % 1440 % 60);
                howLong = (day > 0 ? day + '天' : '') + (h > 0 ? h + '小时' : '') + (m > 0 ? m + '分' : '');
            }
            break;
    }

    return howLong
}

//计算时间差  1:按月算  不超过12月;  2:按天算  不超过30天; 3:按小时算  不超过12小时;
export const isNewDay = (data, type) => {
    let newDay = new Date(), myDay = new Date(data), differDay = '';
    let retDay = '';
    switch (type) {
        case 1:
            differDay = new Date(myDay + 86400000 * 365);
            break;
        case 2:
            differDay = new Date(myDay + 86400000 * 30);
            break;
        case 3:
            differDay = new Date(myDay + 86400000);
            break;
    }
    retDay = (differDay < newDay ? differDay : newDay);
    return retDay;
}

//两个时间之间的时长  type m到分钟 s到秒
export const timeDiff = (stat, end, type) => {
    let sTime = new Date(stat), eTime = new Date(end), h = '';
    let jujin = (eTime - sTime) / 1000;

    let day = Math.floor(jujin / 86400);
    if (type == 'd') {
        day = day + 1;
    }
    ;
    h += (day > 0 ? day + '天' : '');

    if (type == 'd') {
        return h;
    }
    ;

    let hover = Math.floor(jujin % 86400 / 3600);
    h += (hover > 0 ? hover + '小时' : '');

    if (type == 'm' || type == 's') {
        let mouse = Math.floor(jujin % 86400 % 3600 / 60);
        h += (mouse > 0 ? mouse + '分钟' : '');
    }
    if (type == 's' || type == '') {
        let second = Math.floor(jujin % 86400 % 3600 % 60);
        h += (second > 0 ? second + '秒' : '');
    }

    return h;
}


//返回两个时间之间所有的时间  一分为间隔
export const allTimeArr = (stat, end) => {
    let sTime = new Date(stat), eTime = new Date(end), arr = new Array();
    let jujin = (eTime - sTime) / 60000;
    for (let i = 0; i < jujin; i++) {
        let inTime = new Date(sTime - (-i * 60000));
        if (inTime <= eTime) {
            arr.push(getTime(inTime));
        }
    }
    return arr;
}


export const timeSub = (beginDate, endDate) => {
    if (!beginDate) return
    let b = beginDate.split(" ");
    let b1 = b[0].split("-");
    let b3 = b[1].split(".");
    let b2 = b1[0] + '/' + b1[1] + '/' + b1[2] + ' ' + b3[0];

    let e = endDate.split(" ");
    let e1 = e[0].split("-");
    let e3 = e[1].split(".");
    let e2 = e1[0] + '/' + e1[1] + '/' + e1[2] + ' ' + e3[0];

    let date1 = new Date(b2),
        date2 = new Date(e2);

    return Math.floor((date2 - date1) / 60000)
}

//处理保存站点历史查看记录
export const lookHisData = (arr) => {
    let userId = JSON.parse(localStorage.getItem('userInfo')).id
    let hisData = (localStorage.getItem('lookHistData' + userId) == null ? [] : localStorage.getItem('lookHistData' + userId).split('~'));
    if (hisData.length >= 10) {
        hisData.splice(0, 1);
    }

    hisData.forEach(function (item, index) {
        if (item == arr) {
            hisData.splice(index, 1);
            return
        }
    });

    hisData.push(arr);
    localStorage.setItem('lookHistData' + userId, hisData.join('~'));
}

//删除站点历史记录
export const delHisData = (dataId) => {
    let userId = JSON.parse(localStorage.getItem('userInfo')).id
    let hisData = (localStorage.getItem('lookHistData' + userId) == null ? [] : localStorage.getItem('lookHistData' + userId).split('~'));

    if (hisData.length == 0) return;

    hisData.forEach(function (item, index) {
        if (item.split(',')[0] == dataId) {
            hisData.splice(index, 1);
        }
        ;
    });
    localStorage.setItem('lookHistData' + userId, hisData.join('~'));
}

//处理车辆树选中节点
export const carData = (arrData) => {

    let carId = new Array(), comId = new Array(), groupId = new Array();
    let comArr = getArr(arrData, 'type', 'company');
    let groupArr = getArr(arrData, 'type', 'group');
    let carArr = getArr(arrData, 'type', 'car');

    if (comArr.length > 0) {
        comArr.forEach(function (item, index) {
            comId.push(item.id);

            let chilArr = getArr(groupArr, 'companyId', item.id);
            groupArr = removeArr(groupArr, 'companyId', item.id);

            chilArr.forEach(function (list, inde) {
                carArr = removeArr(carArr, 'groupId', list.id);
            });
        });
    }
    ;

    if (groupArr.length > 0) {
        groupArr.forEach(function (list, inde) {
            groupId.push(list.id);
            carArr = removeArr(carArr, 'groupId', list.id);
        });
    }
    ;

    if (carArr.length > 0) {
        carArr.forEach(function (list, inde) {
            carId.push(list.id);
        });
    }
    ;
    let myArr = new Array();
    myArr.push(comId);
    myArr.push(groupId);
    myArr.push(carId);
    return myArr;
}

//格式化数字格式，三个数字一分
export const numFormats = (value) => {
    if (!value) return '0.00';

    var intPart = Number(value).toFixed(0); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

    var floatPart = ".00"; //预定义小数部分
    var value2Array = String(value).split(".");

    //=2表示数据有小数位
    if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分

        if (floatPart.length == 1) { //补0,实际上用不着
            return intPartFormat + "." + floatPart + '0';
        } else {
            return intPartFormat + "." + floatPart;
        }

    } else {
        return intPartFormat + floatPart;
    }
}

//获取路径传参  urlStr 路由，name 要取的值 
export const getUrl = (urlStr, name) => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = urlStr.substr(urlStr.indexOf("?") + 1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

export const timeToTimeAll = (beginDate, endDate) => {
    beginDate = new Date(beginDate);
    endDate = new Date(endDate);
    let day = Math.floor((endDate - beginDate) / 1000 / 86400);
    let arr = new Array();

    let stat = getTime(beginDate);
    let end = getTime(endDate);

    arr.push(stat);
    for (let i = 1; i < day; i++) {
        let myday = new Date(beginDate - (-i * 86400000));
        let y1 = myday.getFullYear();
        let m1 = myday.getMonth() + 1;
        let d1 = myday.getDate();
        m1 = m1 < 10 ? ('0' + m1) : m1;
        d1 = d1 < 10 ? ('0' + d1) : d1;
        arr.push(y1 + '-' + m1 + '-' + d1);
    }
    arr.push(end);
    return arr;
}


//数组去重
export const arrDistin = (arrData) => {
    let i, j, len = arrData.length;
    for (i = 0; i < len; i++) {
        for (j = i + 1; j < len; j++) {
            if (arrData[i].id == arrData[j].id) {
                arrData.splice(j, 1);
                len--;
                j--;
            }
        }
    }
    ;
    return arrData;
}


//异常数据报警时长   秒转为分钟
export const secondToMin = (val) => {
    let h = '';
    if (val > 86400) {
        h += parseInt(val / 86400) + '天';
    }
    if ((val % 86400) > 3600) {
        h += parseInt(val % 86400 / 3600) + '小时';
    }
    h += parseInt(val % 86400 % 3600 / 60) + '分钟';
    return h;
}